import * as React from "react";
import { ViewMode } from "./types";
import { useDispatch } from "./";

export function useActions() {
  const dispatch = useDispatch();

  /**
   * Update the view mode
   */
  const setViewMode = React.useCallback(function setViewMode(
    viewMode: ViewMode
  ) {
    dispatch({ type: "SET_VIEW_MODE", viewMode });
  },
  []);

  return {
    setViewMode,
  };
}
